import React from 'react';
import {motion} from 'framer-motion';
import {useLanguage} from '../context/LanguageContext';

const WhyWorkWithMe=()=> {
  const {t}=useLanguage();
  const imgUrl="https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/ded59f4bc1a1e49e6e28e873c79b4f37.jpg";

  return (
    <section className="py-24 px-6 bg-zinc-950">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{opacity: 0,x: -30}}
            whileInView={{opacity: 1,x: 0}}
            viewport={{once: true}}
            className="lg:col-span-5 relative"
          >
            <div className="aspect-[4/5] rounded-3xl overflow-hidden border border-white/10 shadow-2xl relative group">
              <div className="absolute inset-0 bg-orange-500/10 mix-blend-overlay z-10 transition-opacity duration-500 group-hover:opacity-0" />
              <img
                src={imgUrl}
                alt="Mathias Deppe, digital growth consultant near Barcelona"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="absolute -inset-4 bg-orange-500/20 blur-3xl -z-10 rounded-full opacity-50" />
          </motion.div>

          <motion.div
            initial={{opacity: 0,x: 30}}
            whileInView={{opacity: 1,x: 0}}
            viewport={{once: true}}
            transition={{delay: 0.2}}
            className="lg:col-span-7 flex flex-col justify-center text-left"
          >
            <span className="text-orange-500 font-bold tracking-widest text-sm uppercase mb-4 block">
              {t.whyMe.tag}
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-8">
              {t.whyMe.h2}
            </h2>
            <p className="text-2xl md:text-4xl font-medium text-zinc-300 leading-tight md:leading-snug">
              "{t.whyMe.quote}
              <span className="text-white">{t.whyMe.quoteSpan1}</span>
              {t.whyMe.quote2}
              <span className="text-orange-500">{t.whyMe.quoteSpan2}</span>"
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyWorkWithMe;